import { Alert } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as AlertTriangleIcon } from "components/Icons/alert-triangle.svg";
import { ReactComponent as InfoCircleIcon } from "components/Icons/info-circle.svg";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    warning: {
      //hex with opacity
      backgroundColor: `${theme.orange50}80`,
      whiteSpace: "break-spaces",
      "& div": {
        color: theme.orange700,
        fontWeight: 400,
      },
      "& a": {
        color: theme.orange700,
      },
    },
    info: {
      backgroundColor: theme.primary50,
      color: theme.primary500,
      fontWeight: 400,
      whiteSpace: "break-spaces",
    },
  }),
);

export const InfoBox = ({
  text,
  type,
  variant = "filled",
  className,
  customIcon,
}: {
  text: string;
  variant?: "filled";
  type: "warning" | "success" | "error" | "info";
  className?: string;
  customIcon?: React.ReactElement;
}) => {
  const classes = useStyles();

  const getIcon = () => {
    switch (type) {
      case "warning":
        return <AlertTriangleIcon />;
      case "info":
        return <InfoCircleIcon />;
      default:
        return null;
    }
  };
  const alertIcon = customIcon || getIcon();

  return (
    <Alert
      icon={alertIcon}
      severity={type}
      variant={variant}
      classes={{
        root: className ? className : "",
        filledWarning: classes.warning,
        filledInfo: classes.info,
      }}
    >
      {text}
    </Alert>
  );
};
